import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allPins: [],
  filteredPins: [],
  currentPin: null,
  displayedCount: 20
};

const pinsSlice = createSlice({
  name: 'pins',
  initialState,
  reducers: {
    setAllPins: (state, action) => {
      state.allPins = action.payload;
    },
    setFilteredPins: (state, action) => {
      state.filteredPins = action.payload;
      state.displayedCount = 20;
    },
    setCurrentPin: (state, action) => {
      state.currentPin = action.payload;
    },
    incrementDisplayedCount: (state) => {
      state.displayedCount += 20;
    },
    resetDisplayedCount: (state) => {
      state.displayedCount = 20;
    }
  }
});

export const {
  setAllPins,
  setFilteredPins,
  setCurrentPin,
  incrementDisplayedCount,
  resetDisplayedCount
} = pinsSlice.actions;

export const selectAllPins = (state) => state.pins.allPins;
export const selectFilteredPins = (state) => state.pins.filteredPins;
export const selectDisplayedPins = (state) => 
  state.pins.filteredPins.slice(0, state.pins.displayedCount);
export const selectCurrentPin = (state) => state.pins.currentPin;

export default pinsSlice.reducer;
